import { equipmentAvailabilityOutput, TRAINING_ROUTES, } from "@repo/contract/training";
import { profileKeys } from "./keys";
import { readSection, sectionMutation, sectionOptions, writeSection, } from "./section";
/**
 * The equipment checklist, replaced whole on every `PUT`, and where the
 * person trains (`place`, plan D41).
 *
 * ── `place`: ABSENT KEEPS, `null` CLEARS ───────────────────────────────────
 * The input is serialized as given, and `JSON.stringify` drops a key whose
 * value is `undefined` — so a checklist save that never set `place` sends no
 * `place`, and the server leaves the stored one alone. Send `null` only to
 * clear it. A form that always spreads `place: current ?? null` wipes the
 * place on every checklist save. The answer always carries `place`, `null`
 * when never set; a server older than the field omits it, which decodes too.
 */
const spec = {
    key: profileKeys.equipment,
    name: "equipment",
    output: equipmentAvailabilityOutput,
    path: TRAINING_ROUTES.equipment,
};
/** `GET /me/equipment`. */
export function fetchEquipment(api, init) {
    return readSection(api, spec, init);
}
/** `PUT /me/equipment` — replaces the whole section; answers what is now stored. */
export function putEquipment(api, input) {
    return writeSection(api, spec, input);
}
export function equipmentOptions(api) {
    return sectionOptions(api, spec);
}
export function equipmentMutation(api) {
    return sectionMutation(api, spec);
}
//# sourceMappingURL=equipment.js.map